// extracted by mini-css-extract-plugin
module.exports = {"top":"styles_top__9HCrr","form":"styles_form__2YV_5"};